import { ChangeDetectorRef, Component, Inject, OnInit, ViewChild, ViewRef,LOCALE_ID,EventEmitter,Output } from '@angular/core'
import { ActivatedRoute, Router } from '@angular/router'
import { FormControl } from '@angular/forms'
import { MatDrawer, MatSnackBar } from '@angular/material'
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog'
import { BaseDialogComponent } from '../../../../../base/dialog-base/dialog-base.component'
import { Stringable, StringableValues } from '../../../../../common/stringable.decorator'
import { ONE_MB_IN_BYTES } from '../../../../../constants/FileSize'
import { JSONRpcResponse } from '../../../../../Interfaces/JSONRpcResponse'
import { DialogService, StateService } from '../../../../../services'
import {Observable,	BehaviorSubject, Subject} from "rxjs";
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter } from '@angular/material-moment-adapter';
import * as moment from 'moment';

const KEY = 'ia-dialog'

@Component({
	selector: 'atyl-ia-dialog',
	templateUrl: './ia-dialog.component.html',
	styleUrls: ['./ia-dialog.component.scss'],
  	providers: [
    { provide: LOCALE_ID, useValue: 'fr-FR' },
    { provide: MAT_DATE_LOCALE, useValue: 'fr-FR' },
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },
    { provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { useUtc: false } },
    //{ provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS },
    {
      provide: MAT_DATE_FORMATS, useValue: {
        parse: {
          dateInput: 'L',
        },
        display: {
          dateInput: 'L',
          monthYearLabel: 'MMM YYYY',
          dateA11yLabel: 'L',
          monthYearA11yLabel: 'MMM YYYY',
        },
      }
    },
  ],
})
@Stringable({
	path: 'views/partials/content/general/ia',
	key: KEY,
})
export class IaDialogComponent extends BaseDialogComponent implements OnInit {

	@StringableValues(KEY) strings: any

	@ViewChild('drawer', { static: false }) drawer: MatDrawer
	config: any = {
		placeholder: 'Label',
		height: '15vh',
		toolbar: [
			['style', ['bold', 'italic', 'underline']],
			['para', ['ul', 'ol', 'paragraph', 'height']],
			['insert', ['table']]
		],
		disableDragAndDrop: true
	};
	instruction:any;
	
	toLoadIA:BehaviorSubject<boolean>=new BehaviorSubject<boolean>(false);
		
    
    
    askInput:any;
     
	constructor(
		public dialogRef: MatDialogRef<IaDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any,
		public stateService: StateService,			
		changeDetectorRef: ChangeDetectorRef,
		dialogService: DialogService,
		private router: Router,
		private activatedRoute: ActivatedRoute,
	) {
		super(dialogRef, dialogService, changeDetectorRef)
	}

	ngOnInit() {
		
		
		
		
		if (this.data.ask!=undefined && this.data.ask ) {
			this.askInput = this.data.ask;
		}
		
		this.toLoadIA.next(true);
	}

	detectChanges() {
        setTimeout(() => {
            if (this.changeDetectorRef && !(this.changeDetectorRef as ViewRef).destroyed) {
                this.changeDetectorRef.detectChanges()
            }
        })
    }
    
    
	
	
}
